import * as yup from 'yup';

import {
    propFieldTypes as injectionPropFieldTypes
} from "../../../../hooks/api/useInjectionProps"

import {
    fieldDataTypes as injectionFieldDataTypes,
    moduleTypes as injectionFieldModuleTypes
} from "../../../../hooks/api/useInjectionFields"

const defCustomInjectionFields = { ref: injectionFieldModuleTypes.user.customer.ref, module: injectionFieldModuleTypes.user.customer.module }

export const customInjectionFields = {
    marking: { submitKey: "customer_markings", retrieveKey: "inf_usr_cust_customer_markings", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    sourceClientRemId: { submitKey: "source_client_remid", retrieveKey: "inf_usr_cust_source_client_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    sourceAgentRemId: { submitKey: "source_agent_remid", retrieveKey: "inf_usr_cust_source_agent_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    sourceProfileType: { submitKey: "source_profile_type", retrieveKey: "inf_usr_cust_source_profile_type", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
}

export const customInjectionPropsBk = {
    marking: {
        submitKey: "customer_markings",
        retrieveKey: "inj_cust_usr_customer_markings",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        // propIsMultiple: 1, // multiple
        propIsMultiple: 0, // multiple
        getValue: (val) => {
            return val
        }
    },

    // scheduler
    sourceClientRemId: {
        submitKey: "source_client_remid",
        retrieveKey: "inj_cust_usr_source_client_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },
    sourceAgentRemId: {
        submitKey: "source_agent_remid",
        retrieveKey: "inj_cust_usr_source_agent_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },
    sourceProfileType: {
        submitKey: "source_profile_type",
        retrieveKey: "inj_cust_usr_source_profile_type",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    }
}

// temp override this
export const customInjectionProps = customInjectionFields

export const validateRowSchema = yup.object().shape({
    marking: yup
        .string()
        .required("Required"),
})

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    username: yup
        .string()
        .required('Required'),
    firstname: yup
        .string()
        .required('Required'),
    lastname: yup
        .string()
        .required('Required'),
    companyname: yup
        .string()
        .required('Required'),
    regno: yup
        .string()
        .required('Required'),
    code: yup
        .string()
        .required('Required'),
    accountcode: yup
        .string()
        .required('Required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Required'),
    // contactno: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    status: yup
        .bool()
        .required('Required'),

    rows: yup
        .array()
        .of(validateRowSchema),
})

export const initialPasswordValues = {
    password: "",
    passwordconfirm: "",
}

export const initialRowValues = {
    marking: "",
}

export const initialValues = {
    username: "",
    firstname: "",
    lastname: "",
    contactno: "",
    companyname: "",
    regno: "",
    code: "",
    accountcode: "",
    email: "",
    status: true,
    remark: "",
    salesperson: "",
    rows: [initialRowValues],
}